export default {
      id: "ic_contact-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_contact-usage",
      toString: function () {
        return this.url;
      }
    }